import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import MaxDiffState, {TMaxDiffRow} from "../MaxDiffState";
import MaxDiffCard from "./MaxDiffCard";
import MaxDiffDropTarget from "./MaxDiffDropTarget";
import MaxDiff from "../MaxDiff";
import Sortable from "sortablejs";

export default class MaxDiffDragdrop extends MaxDiff {

    private readonly winTarget: MaxDiffDropTarget;
    private readonly loseTarget: MaxDiffDropTarget;

    private readonly cards: Map<TMaxDiffRow, MaxDiffCard> = new Map<TMaxDiffRow, MaxDiffCard>();

    private forceRedraw = false;
    public dragging = false;

    private self: MaxDiffDragdrop;
    public touchingTarget: null|number = null;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.self = this;
        this.winTarget = new MaxDiffDropTarget(this.winLabel, MaxDiffState.RATING_WIN, this);
        this.loseTarget = new MaxDiffDropTarget(this.loseLabel, MaxDiffState.RATING_LOSE, this);

        this.state.rows.forEach( (row) => this.cards.set(row, new MaxDiffCard(this, row)) );
    }

    private viewTargets(): Vnode {
        return m('.targets', {}, [
            m(this.winTarget),
            this.state.isFinalRound() ? null : m(this.loseTarget),
        ])
    }

    private viewCards(): Vnode|null {
        if (this.forceRedraw) {
            return null;
        }
        // Force redraw cards - remove them
        return m('.cards', {
                oncreate: vnode => {
                    new Sortable(<HTMLElement>vnode.dom, {
                        group: {
                            name: 'MaxDiffDragdrop',
                            pull: 'clone',
                            put: false,
                        },
                        sort: false,
                        forceFallback: true,
                        onStart: () => {
                            this.dragging = true;
                            m.redraw();
                        },
                        onEnd: () => {
                            this.dragging = false;
                            this.self.touchingTarget = null;
                            m.redraw();
                        },
                    });
                },
            }, this.state.getCurrentRows()
            .map(row => this.cards.get(row))
            .map(card => card ? m(card) : null)
        );
    }


    protected onClickPrev() {
        super.onClickPrev();
        this.forceRedrawWithTimeout();
    }

    protected onClickNext() {
        super.onClickNext();
        this.forceRedrawWithTimeout();
    }

    /**
     * Hack mithril to force redraw, which is rebuild containers for Sortablejs
     */
    public forceRedrawWithTimeout(): void {
        this.forceRedraw = true;
        m.redraw();
        setTimeout(() => {
            this.forceRedraw = false;
            m.redraw();
        }, 17)
    }

    public view(): Vnode {
        return this.viewLayout(
            m('.MaxDiff', {
                oncreate: vnode => {
                    const el = <HTMLElement>vnode.dom;

                    // fix controls jumping on force redraw
                    el.style.minHeight = (<HTMLElement>vnode.dom).offsetHeight+'px';

                    // call touchmove event outside mithril to prevent redraw when it is not necessary
                    el.addEventListener('touchmove', (e: TouchEvent) => {
                        let target = null;
                        document.elementsFromPoint(e.touches[0].clientX, e.touches[0].clientY)
                            .filter(el => el.classList.contains('target'))
                            .forEach(el => target = Number((<HTMLElement>el).dataset.rating));
                        if (this.touchingTarget !== target) {
                            this.self.touchingTarget = target;
                            m.redraw();
                        }
                    });
                },
            }, [
                m('.MaxDiffDragNDrop'+(this.dragging?'.dragging':''), {}, [
                    this.viewTargets(),
                    this.viewCards(),
                ]),
                this.viewProgress(),
            ])
        );
    }
}